import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { IrbEditorsService } from "@irb/irb-editors/irb-editors.service";
import { UtilityService } from "@irb-common/services/utility.service";
import { IDropdownItem } from '@irb-common/models/dropdown.model';
import { AppService } from "@irb/app.service";

@Component({ standalone: false,
  selector: 'irb-com-assign-portfolio',
  templateUrl: './com-assign-portfolio.component.html',
  styleUrls: ['./com-assign-portfolio.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComAssignPortfolioComponent implements OnInit {

  @Output() change = new EventEmitter<boolean>();
  @Output() navigate = new EventEmitter<number>();

  _data: any;
  private _portfolioTarget: IDropdownItem;
  originalPortfolioTarget: IDropdownItem;
  _isModified: boolean = false;

  constructor(private ies: IrbEditorsService, private util: UtilityService) {}

  ngOnInit() {
    this.portfolioTarget = {
      name: this.data.portfolio,
      value: this.data.portfolioId
    };

    this.originalPortfolioTarget = this.util.clone(this.portfolioTarget);
  }
  showEditPortfolio() {
    this.navigate.emit(this.portfolioTarget.value);
  }

  onInputChange() {
    this.change.emit(true);
  }

  @Input()
  get data(): any {
    return this._data;
  }

  set data(d: any) {
    this._data = d;
  }

  public get portfolioTarget(): IDropdownItem {
    return this._portfolioTarget;
  }
  
  public set portfolioTarget(value: IDropdownItem) {
    this._portfolioTarget = value;
  }

  @Input()
  get isModified(): boolean {
    return this._isModified;
  }

  set isModified(isModified: boolean) {
    this._isModified = isModified;
  }
}
